<template>
    <v-container fluid>
      <!-- Tenants Section -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-section">
            <v-card-title class="card-title">
              <v-icon left>mdi-account-group</v-icon> <!-- Group Icon for Tenants -->
              Tenants
            </v-card-title>
            <v-card-text>
              <!-- Progress Bar for Tenants -->
              <v-progress-linear
                :value="tenantPropertiesPercentage"
                color="#FFD700"  
                :buffer-value="100"
                class="progress-bar"
                height="30" 
                @click="goToPage('/Tenants')" >
                <template v-slot:default>
                  <!-- Details slot displaying tenant count -->
                  <div class="progress-text">
                    {{ occupiedTenantsCount }} Tenants
                  </div>
                </template>
              </v-progress-linear>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { getDocs, collection, getFirestore } from "firebase/firestore";
  const db = getFirestore();
  
  export default {
    data() {
      return {
        tenants: [],
      };
    },
    computed: {
      // Compute total tenants and occupied tenant count
      totalTenants() {
        return this.tenants.length;
      },
      occupiedTenantsCount() {
        return this.tenants.filter(tenant => !tenant.isVacant).length;
      },
      tenantPropertiesPercentage() {
        if (this.totalTenants === 0) return 0;
        const percentage = (this.occupiedTenantsCount / this.totalTenants) * 100;
        return isNaN(percentage) ? 0 : percentage;
      },
    },
    async created() {
      await this.fetchTenants();  // Call fetchTenants method on component creation
    },
    methods: {
      async fetchTenants() {
        try {
          const querySnapshot = await getDocs(collection(db, "tenants"));
          const tenants = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
              tenant: data.reference, // Set tenant to reference
              displayName: data.displayName, // Set displayName for tenant's name
              isVacant: data.isVacant, // Add isVacant to check if tenant is still in place
            };
          });
  
          // Sort tenants by reference (if reference is a string or number)
          tenants.sort((a, b) => {
            if (a.tenant < b.tenant) return -1;
            if (a.tenant > b.tenant) return 1;
            return 0;
          });
  
          // Assign the sorted tenants to the data property
          this.tenants = tenants;
          console.log("Fetched tenants:", tenants);  // Log to check fetched data
        } catch (error) {
          console.error("Error fetching tenants:", error);
        }
      },
      goToPage(page) {
      this.$router.push(page);
    },
    },
  };
  </script>
  
  <style scoped>
  .card-section {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
  }
  
  .card-title {
    font-size: 20px;
    font-weight: bold;
    color: #1e88e5;
  }
  
  .progress-bar {
    margin-bottom: 12px;
  }
  
  .progress-text {
    color: white; /* Ensures the text is visible inside the progress bar */
    text-align: center;
    font-weight: bold;
  }
  
  .data-item {
    margin-top: 8px;
    font-size: 16px;
  }
  </style>
  